
      import '@folkjs/labs/standalone/folk-shape';
      import { FolkEventPropagator } from '@folkjs/labs/standalone/folk-event-propagator';

      class CutTool {
        entry() {
          document.addEventListener('pointerdown', this, { capture: true });
        }
        exit() {
          document.removeEventListener('pointerdown', this, { capture: true });
        }

        handleEvent(event) {
          // Stop the default focus and pointer capture of geometry elements
          event.preventDefault();
          event.stopPropagation();

          switch (event.type) {
            case 'pointerdown': {
              document.addEventListener('pointermove', this);
              document.addEventListener('pointerup', this);
              return;
            }
            case 'pointermove': {
              if (event.target instanceof FolkEventPropagator) {
                const percent = event.target.getPercentageFromPoint({ x: event.clientX, y: event.clientY });
                event.target.cut(percent);
              }
              return;
            }
            case 'pointerup': {
              document.removeEventListener('pointermove', this);
              document.removeEventListener('pointerup', this);
              return;
            }
          }
        }
      }

      class MendTool {
        entry() {
          document.addEventListener('pointerdown', this, { capture: true });
        }
        exit() {
          document.removeEventListener('pointerdown', this, { capture: true });
        }

        handleEvent(event) {
          // Stop the default focus and pointer capture of geometry elements
          event.preventDefault();
          event.stopPropagation();

          switch (event.type) {
            case 'pointerdown': {
              document.addEventListener('pointermove', this, { capture: true });
              document.addEventListener('pointerup', this, { capture: true });
              return;
            }
            case 'pointermove': {
              if (event.target instanceof FolkEventPropagator) {
                event.target.mend();
              }
              return;
            }
            case 'pointerup': {
              document.removeEventListener('pointermove', this, { capture: true });
              document.removeEventListener('pointerup', this, { capture: true });
              return;
            }
          }
        }
      }

      const tools = new Map();

      tools.set(window.cut, new CutTool());

      tools.set(window.mend, new MendTool());

      let activeTool = null;

      document.addEventListener('click', (e) => {
        const tool = tools.get(event.target);

        if (tool === undefined) return;

        activeTool?.exit();

        if (tool === activeTool) {
          activeTool === null;
        } else {
          activeTool = tool;
          activeTool.entry();
        }
      });
    